import { createContext } from 'react';

const GroupsContext = createContext();

export default GroupsContext;




